import { useMemo, useState } from 'react'
import { useHistory, useLocation } from 'react-router'

const useBillingManagementFilters = () => {
  const [omnisearchVal, setOmnisearchVal] = useState('')
  const [rateToFilter, setRateToFilter] = useState('any')
  const [trackingToFilter, setTrackingToFilter] = useState('any')
  const [showRejected, toggleShowRejected] = useState(false)
  const [showNonRejected, toggleShowNonRejected] = useState(true)
  const [showAnomaly, setShowAnomaly] = useState(false)
  const [rateCategoryToFilter, setRateCategoryToFilter] = useState('any')
  const [filteredConversionReason, setFilteredConversionReason] = useState(
    'Any conversion reason'
  )
  const [priorStayCount, setPriorStayCount] = useState('Any prior stays')

  const location = useLocation()
  const history = useHistory()

  const queryParams = new URLSearchParams(location.search)

  function setFilterValue(name, value) {
    switch (name) {
      case 'omnisearch':
        queryParams.delete('q')
        history.replace({ search: queryParams.toString() })
        setOmnisearchVal(value)
        break

      case 'rate':
        setRateToFilter(value)
        break

      case 'tracking':
        setTrackingToFilter(value)
        break

      case 'rejected':
        toggleShowRejected(!showRejected)
        break

      case 'nonRejected':
        toggleShowNonRejected(!showNonRejected)
        break

      case 'conversionReason':
        setFilteredConversionReason(value)
        break

      case 'priorStaysCount':
        setPriorStayCount(value)
        break

      case 'anomaly':
        setShowAnomaly(a => !a)
        break

      case 'rateCategory':
        setRateCategoryToFilter(value)
        break

      default:
        break
    }
  }

  const values = useMemo(
    () => ({
      omnisearchVal,
      rateToFilter,
      trackingToFilter,
      showRejected,
      showNonRejected,
      filteredConversionReason,
      priorStayCount,
      showAnomaly,
      rateCategoryToFilter
    }),
    [
      filteredConversionReason,
      omnisearchVal,
      priorStayCount,
      rateToFilter,
      showNonRejected,
      showRejected,
      showAnomaly,
      trackingToFilter,
      rateCategoryToFilter
    ]
  )

  return [values, setFilterValue]
}

export default useBillingManagementFilters
